import React, { FC, useEffect, useState } from 'react';
import { Skeleton } from '@material-ui/lab';
import { LegacyDomain } from 'src/interfaces/api/Domain';
import useAuth from 'src/hooks/api/useAuth';
import { FormControl, InputLabel, OutlinedInput, Select } from '@material-ui/core';

interface Props {
  className?: any;
  label?: string;
  value?: LegacyDomain['id'];
  onChange: (domainId?: LegacyDomain['id']) => void;
}

const LegacyDomainSelect: FC<Props> = React.forwardRef<any, Props>(({ value, label, onChange }, ref) => {
  const [domains, setDomains] = useState<LegacyDomain[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const { fetch } = useAuth();

  const fetchDomains = (): Promise<LegacyDomain[]> => {
    const queryURL = `/api/domains/{ domains{id, name} }`;

    return fetch(queryURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['domains']) {
          return data['data']['domains'];
        }

        throw new Error('Aucun domaine trouvé ...');
      });
  };

  const handleDomainChange = (event) => {
    const value = event.target.value;
    onChange(parseInt(value, 10));
  };

  useEffect(() => {
    fetchDomains()
      .then((domains) => {
        setDomains(domains);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Skeleton height={50} />;
  }

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <FormControl variant='outlined' size='small' fullWidth>
      <InputLabel>{label || 'Domaine'}</InputLabel>
      <Select
        native
        value={value || ''}
        onChange={handleDomainChange}
        input={<OutlinedInput label={label || 'Domaine'} />}
      >
        <option value='' />
        {domains.map((domain) => (
          <option key={domain.id} value={domain.id}>
            {domain.name}
          </option>
        ))}
      </Select>
    </FormControl>
  );
});

export default React.memo(LegacyDomainSelect);
